import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CadastroPage } from '../../pages/cadastro/cadastro';
import { environment } from '../../environments/environment.dev';

/**
 * Generated class for the DrawerHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'drawer-header',
  templateUrl: 'drawer-header.html'
})
export class DrawerHeaderComponent {

  text: string;

  @Input() user: any

  constructor(private navController: NavController) {
    console.log('Hello DrawerHeaderComponent Component');
    this.text = 'Hello World';
  }
  
  editUser() {
    this.navController.push(CadastroPage, {
      isEdition: true
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/drawer-header/drawer-header.ts